import {ListItemSecondaryAction, ListItemText} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import {Download} from "@mui/icons-material";
import React, {useEffect, useState} from "react";
import {SUCCESS, FAILED} from "../../httpClient";
import {useAuth} from "oidc-react";
import {loadPresignedUrls} from "../../features/user/userAPI";
import moment from "moment/moment";

export const FileDownloadNotificationListItem = (details) => {

    const [presignedUrls, setPreSignedUrls] = useState([]);
    const [status, setStatus] = useState("");
    const auth = useAuth();

    useEffect(() => {
        if (auth && auth.userData && status !== SUCCESS) {
            const filePath = details.details["s3Key"] + "/" + details.details["fileName"];
            const downloadPath = [filePath];
            loadPresignedUrls(auth.userData.access_token, JSON.stringify(downloadPath))
                .then(data => {
                    setPreSignedUrls(data);
                    setStatus(SUCCESS);
                })
                .catch(err => {
                    console.log(err);
                    setStatus(FAILED);
                })
        }
    }, [presignedUrls, auth.userData]);

    const smartDownload = () => {
        fetch(presignedUrls[0])
            .then(resp => {
                if (resp.ok) {
                    return resp.blob();
                }
                throw resp
            })
            .then(data => {
                const fileName = details.details["fileName"];
                const format = fileName.split('.').pop();
                if (format === 'pdf') {
                    const file = new Blob([data], {type: 'application/pdf'});
                    const fileUrl = URL.createObjectURL(file);

                    window.open(fileUrl, '_blank');
                }else {
                    let a = document.createElement("a")
                    let blobURL = URL.createObjectURL(data)
                    a.download = details.details["fileName"]
                    a.href = blobURL
                    document.body.appendChild(a)
                    a.click()
                    document.body.removeChild(a)
                }
                setStatus(SUCCESS);
            })
            .catch(() => {
                setStatus(FAILED);
                setInterval(() => setStatus(''),6000);
            });
    }



    return (
        <>
            <ListItemText primary={'Notification'}
                          secondary={details.details.type.replace("-", " ")}/>
            {
                status === SUCCESS ?
                    <>
                        <ListItemText primary={'File'}
                                      secondary={`${details.details["fileName"]}`}/>

                        <ListItemText primary={'Message'}
                                      secondary={`Your file is ready to be downloaded`}/>

                        <ListItemSecondaryAction>
                            <IconButton onClick={() => smartDownload()}>
                                <Download color={'info'}/>
                            </IconButton>
                        </ListItemSecondaryAction>
                    </>
                    :
                    <ListItemText primary={'Message'}
                                  secondary={`We are still processing your file..`}/>
            }
        </>
    )
}
